
import React from 'react';
import BackgroundGradients from './BackgroundGradients';
import FirePoiWaves from './FirePoiWaves';
import FloatingParticles from './FloatingParticles';
import GridOverlay from './GridOverlay';

const BackgroundAnimations = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-0">
      <BackgroundGradients />
      
      {/* Animated geometric shapes and gradients */}
      <div className="absolute inset-0 opacity-20">
        <FirePoiWaves />
        <FloatingParticles />
        <GridOverlay />
      </div>
      
      {/* Depth overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-slate-800/20"></div>
    </div>
  );
};

export default BackgroundAnimations;
